import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import {appVersion, publicUrl} from './AppConfig'
import {BrowserRouter as Router} from 'react-router-dom'
import * as Sentry from '@sentry/react'
import axios from 'axios'
import AppContextProvider from '@/api/app/AppContext'
import {StyleRoot} from 'radium'
import MobileApp from '@/MobileApp'
import appApi from '@/api/app/AppApi'
import identityApi from '@/api/identity/IdentityApi'
import incomeApi from '@/api/income/IncomeApi'

console.log(`App version: ${appVersion}`)

// Use Vite env for basename
const basename = `/${publicUrl}`.replace(/\/{2,}/g, '/')

// Only enable Sentry on allowed domains and in production
const allowedDomains = [
  'https://sky.prod.sprinthive.com',
  'https://asp.prod.sprinthive.com',
  'https://omf.prod.sprinthive.com',
  'https://tym.prod.sprinthive.com',
  'https://verify.wfs.co.za'
]
const isSentryEnabled = allowedDomains.includes(window.location.origin) && import.meta.env.PROD

Sentry.init({
  dsn: "https://a92d924d85b4776507238bd390b58e9e@o4504718797832192.ingest.us.sentry.io/4507141766447104",
  integrations: [
    Sentry.browserTracingIntegration()
  ],
  tracesSampleRate: 0.3,
  enabled: isSentryEnabled,
  environment: import.meta.env.MODE,
  release: appVersion
})

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response && error.request) {
      Sentry.captureException(error)
    }
    return Promise.reject(error)
  }
)

const container = document.getElementById('root')
if (container) {
  const root = ReactDOM.createRoot(container)
  root.render(
    <React.StrictMode>
      <Router basename={basename}>
        <AppContextProvider appApi={appApi} identityApi={identityApi} incomeApi={incomeApi}>
          <StyleRoot>
            <MobileApp/>
          </StyleRoot>
        </AppContextProvider>
      </Router>
    </React.StrictMode>
  )
}